import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import SalesMaintenance from "../SalesMaintenance";
import { Accordion, Spinner, Modal } from "react-bootstrap";
import { Steps, Button, Select } from "antd";
import {
  fetchTargetPeriod,
  fetchMarketAuthorizationList,
  fetchFormList,
  fetchFormulationList,
  fetchPackagingList,
  getSelloutRotationReportList,
  fetchFixedMonth,
  fetchMaintenanceList,
  fetchProductsList,
  fetchEvaluationTargetClassificationList,
  fetchTwoHundredBedsList,
  fetchHundredBedsList,
} from "./actions";
import { List } from "rc-field-form";

function SelloutRotationFacility() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [lang] = useTranslation("language");
  const [allSelected, setAllSelected] = useState(0);
  const [showUserMessage, setShowUserMessage] = useState(false);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [targetPeriod, setTargetPeriod] = useState("0");
  const [duration, setDuration] = useState("");
  const [alertPeriod, setAlertPeriod] = useState("");
  const [facilityType, setFacilityType] = useState(1);
  const [hundredFloorId, setHundredFloorId] = useState("");
  const [twoHundredFloorId, setTwoHundredFloorId] = useState("");
  const [evaluationTargetId, setEvaluationTargetId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDateDisplay, setFromDateDisplay] = useState("");
  const [toDateDisplay, setToDateDisplay] = useState("");
  const [sortItem, setSortItem] = useState("parent_facility_code");
  const [numericalItem, setNumericalItem] = useState("drugPrice");
  const [processingDate, setProcessingDate] = useState("");
  const [doubleCountStatus, setDoubleCountStatus] = useState(false);
  const [personInCharge, setPersonInCharge] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [showDownloadMessage, setShowDownloadMessage] = useState(false);
  const [marketLoading, setMarketLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [formulationLoading, setFormulationLoading] = useState(false);
  const [packLoading, setPackLoading] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState("");
  const [lazyLoading, setLazyLoading] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(true);
  const [limit, setLimit] = useState(100);
  const [total, setTotal] = useState(0);
  const [maintenance, setMaintenance] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const [sortPerson, setSortPerson] = useState("asc");
  const [sortParentFacility, setSortParentFacility] = useState("asc");
  const [sortDeliveryFacility, setSortDeliveryFacility] = useState("asc");
  const [sortProduct, setSortProduct] = useState("asc");
  const [sortMarket, setSortMarket] = useState("asc");
  const [sortForm, setSortForm] = useState("asc");
  const [sortFormulation, setSortFormulation] = useState("asc");
  const [sortPack, setSortPack] = useState("asc");
  const [sortNonDeliveryPeriod, setSortNonDeliveryPeriod] = useState("asc");
  const [loginName, setLoginName] = useState("");

  const [alertPeriodOptions, setAlertPeriodOptions] = useState([]);
  const [hundredBedsList, setHundredBedsList] = useState([]);
  const [twoHundredBedsList, setTwoHundredBedsList] = useState([]);
  const [
    evaluationTargetClassificationList,
    setEvaluationTargetClassificationList,
  ] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedMarketAuth, setSelectedMarketAuth] = useState([]);
  const [selectedForm, setSelectedForm] = useState([]);
  const [selectedFormulation, setSelectedFormulation] = useState([]);
  const [selectedPackaging, setSelectedPackaging] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [marketAuthList, setMarketAuthList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [formulationList, setFormulationList] = useState([]);
  const [packagingList, setPackagingList] = useState([]);
  const [reportListing, setReportListing] = useState([]);
  const [headers, setHeaders] = useState([]);

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("SalesMenu.selloutRotationByFacility")}`,
      path: "/selloutRotationReportFacility",
    },
  ];

  // const alertPeriodOptions = [
  //   { value: "1", label: "1" },
  //   { value: "2", label: "2" },
  //   { value: "3", label: "3" },
  //   { value: "3", label: "3" },
  //   { value: "3", label: "3" },
  //   { value: "3", label: "3" },
  //   { value: "3", label: "3" },
  // ];

  const details = useSelector((state) => state.salesReport.selloutFacility);
  var personName;
  if (sessionStorage.getItem("User role") === "MR") {
    personName = sessionStorage.getItem("Kanji name");
  } else {
    personName = "";
  }
  if (details.length > 1) {
    personName = "複数選択";
  } else if (details.length === 0) {
    if (sessionStorage.getItem("User role") === "MR") {
      personName = sessionStorage.getItem("Kanji name");
    } else {
      personName = "";
    }
  } else if (details.length === 1) {
    if (details[0].role_code  === "5003") {
      personName = details[0].name_kanji;
    } else personName = "";
  }

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const productList = sessionStorage.getItem("Product");
    const marketAuthList = sessionStorage.getItem("Market Auth List");
    const formList = sessionStorage.getItem("Form");
    const formulationList = sessionStorage.getItem("Formulation");
    const packList = sessionStorage.getItem("Pack");
    const hundredBeds = sessionStorage.getItem("Hundred beds sales");
    const twoHundredBeds = sessionStorage.getItem("Two hundred beds sales");
    const evaluationList = sessionStorage.getItem(
      "Evaluation target classification"
    );
    let name = sessionStorage.getItem("Kanji name");
    setLoginName(name);
    let products = JSON.parse(productList);
    let newList = [];
    for (let i = 0; i < products?.length; i++) {
      newList.push(products[i]);
    }
    
    setProductsList(newList);
    sessionStorage.setItem("return_url", "/selloutRotationReportFacility");
    // newList && newList[0] && setSelectedProducts([newList[0].value]);
    setMarketAuthList(JSON.parse(marketAuthList));
    setFormList(JSON.parse(formList));
    setFormulationList(JSON.parse(formulationList));
    setPackagingList(JSON.parse(packList));
    hundredBeds && setHundredBedsList(JSON.parse(hundredBeds));
    twoHundredBeds && setTwoHundredBedsList(JSON.parse(twoHundredBeds));
    evaluationList &&
      setEvaluationTargetClassificationList(JSON.parse(evaluationList));
    hundredBeds &&
      JSON.parse(hundredBeds)[0] &&
      setHundredFloorId(JSON.parse(hundredBeds)[0].value);
    twoHundredBeds &&
      JSON.parse(twoHundredBeds)[0] &&
      setTwoHundredFloorId(JSON.parse(twoHundredBeds)[0].value);
    evaluationList &&
      JSON.parse(evaluationList)[0] &&
      setEvaluationTargetId(JSON.parse(evaluationList)[0].value);
    setPersonInCharge(sessionStorage.getItem("WWID"));
    setOrganizationName(sessionStorage.getItem("Organization name"));
    !sessionStorage.getItem("Product") && getProductList();
    !sessionStorage.getItem("Market Auth List") && getMarketAuthorizationList();
    !sessionStorage.getItem("Form") && getFormList();
    !sessionStorage.getItem("Formulation") && getFormulationList();
    !sessionStorage.getItem("Pack") && getPackList();
    !sessionStorage.getItem("Hundred beds sales") && getHundredBedsList();
    !sessionStorage.getItem("Two hundred beds sales") &&
      getTwoHundredBedsList();
    !sessionStorage.getItem("Evaluation target classification") &&
      getEvaluationTargetClassificationList();
    token && getTargetPeriod();
    getMaintenanceTime();
    getFixedMonth();
    let list = [];
    for (let i = 1; i <= 36; i++) {
      let obj = { value: i, label: i };
      list = [...list, obj];
    }
    setAlertPeriodOptions(list);
  }, []);

  /*** 
  @purpose : Get hundred beds sales list
  @Parameter : {}
  **/
  const getHundredBedsList = async () => {
    await fetchHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setHundredFloorId(newList[0].value);
      setHundredBedsList(newList);
      sessionStorage.setItem("Hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get two hundred beds sales list
  @Parameter : {}
  **/
  const getTwoHundredBedsList = async () => {
    await fetchTwoHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setTwoHundredFloorId(newList[0].value);
      setTwoHundredBedsList(newList);
      sessionStorage.setItem("Two hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get evaluation target classification
  @Parameter : {}
  **/
  const getEvaluationTargetClassificationList = async () => {
    await fetchEvaluationTargetClassificationList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setEvaluationTargetId(newList[0].value);
      setEvaluationTargetClassificationList(newList);
      sessionStorage.setItem(
        "Evaluation target classification",
        JSON.stringify(newList)
      );
    });
  };

  /*** 
  @purpose : Get product list
  @Parameter : {}
  **/
  const getProductList = async () => {
    await fetchProductsList().then((res) => {
      let newList = [];
      if (res && res.length > 0) {
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.prdctlvl_cd,
            label: item.prdctlvl_sym,
          });
        }
        setProductsList(newList);
        sessionStorage.setItem("Product", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get market auth list
  @Parameter : {}
  **/
  const getMarketAuthorizationList = async () => {
    let body = {
      prdctlvl_cd: "ALL",
    };
    await fetchMarketAuthorizationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
        sessionStorage.setItem("Market Auth List", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get form list
  @Parameter : {}
  **/
  const getFormList = async () => {
    let body = {
      aprlvl_cd: "ALL",
      // "market_authorization": "ALL"
    };
    await fetchFormList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
        sessionStorage.setItem("Form", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get formulation list
  @Parameter : {}
  **/
  const getFormulationList = async () => {
    let body = {
      frmlvl_cd: "ALL",
      // "market_authorization": "ALL",
      // "form_codes": "ALL"
    };
    await fetchFormulationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
        sessionStorage.setItem("Formulation", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get pack list
  @Parameter : {}
  **/
  const getPackList = async () => {
    let body = {
      stdlvl_cd: "ALL",
    };
    await fetchPackagingList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
        sessionStorage.setItem("Pack", JSON.stringify(newList));
      }
    });
  };

  /*** 
    @purpose : Get maintenance time period
    @Parameter : {}
    **/
  const getMaintenanceTime = async () => {
    let body = {
      userType: "CA",
      report_type: "monthly-sellout",
    };
    await fetchMaintenanceList(body).then((response) => {
      setIsScreenLoading(false);
      setMaintenance(response && response.data && response.data.odsFlag);
    });
  };

  /*** 
    @purpose : Close modal
    @Parameter : {}
    **/
  const handleClose = () => setShow(false);

  /*** 
    @purpose : Show modal
    @Parameter : {}
    **/
  const modalShow = (value) => {
    setShow(true);
  };

  /*** 
  @purpose : Close user modal
  @Parameter : {}
  **/
  const handleCloseUserMessage = () => setShowUserMessage(false);

  /*** 
  @purpose : Close download message modal
  @Parameter : {}
  **/
  const handleCloseDownloadMessage = () => setShowDownloadMessage(false);

  /*** 
  @purpose : Get target period
  @Parameter : {}
  **/
  const getTargetPeriod = async () => {
    sessionStorage.setItem("return_url", "");
    await fetchTargetPeriod("selloutRotation").then((response) => {
      setProcessingDate(
        response && response.processing_date ? response.processing_date.split(" ")[0] : ""
      );
    });
  };

  /*** 
  @purpose : Get fixed month
  @Parameter : {}
  **/
  const getFixedMonth = async () => {
    await fetchFixedMonth().then((response) => {
      let month = "";
      let toMonth = "";
      let date = response.fixed_month_japan_calendar.fromDate.split("/");
      let toDate = response.fixed_month_japan_calendar.toDate.split("/");
      if (date[1] === "01") month = "January";
      else if (date[1] === "02") month = "February";
      else if (date[1] === "03") month = "March";
      else if (date[1] === "04") month = "April";
      else if (date[1] === "05") month = "May";
      else if (date[1] === "06") month = "June";
      else if (date[1] === "07") month = "July";
      else if (date[1] === "08") month = "August";
      else if (date[1] === "09") month = "September";
      else if (date[1] === "10") month = "October";
      else if (date[1] === "11") month = "November";
      else if (date[1] === "12") month = "December";

      if (toDate[1] === "01") toMonth = "January";
      else if (toDate[1] === "02") toMonth = "February";
      else if (toDate[1] === "03") toMonth = "March";
      else if (toDate[1] === "04") toMonth = "April";
      else if (toDate[1] === "05") toMonth = "May";
      else if (toDate[1] === "06") toMonth = "June";
      else if (toDate[1] === "07") toMonth = "July";
      else if (toDate[1] === "08") toMonth = "August";
      else if (toDate[1] === "09") toMonth = "September";
      else if (toDate[1] === "10") toMonth = "October";
      else if (toDate[1] === "11") toMonth = "November";
      else if (toDate[1] === "12") toMonth = "December";
      setFromDateDisplay(month + " " + date[0]);
      setToDateDisplay(toMonth + " " + toDate[0]);
      setFromDate(date.join(""));
      setToDate(toDate.join(""));
    });
  };

  const handleAllSelected = (e) => {
    setAllSelected(e.target.checked ? 1 : 0);
  };

  const handleDuration = (e) => {
    setDuration(e.target.checked);
  };

  const handleAlertPeriodChange = (value) => {
    setAlertPeriod(value.value);
  };

  const handleProductSelect = async (e) => {
    let list = [];
    list = [...selectedProducts, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        prdctlvl_cd: list1,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
      setSelectedProducts(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        prdctlvl_cd: list2,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
      setSelectedProducts(list2);
    }
  };

  const handleMarketAuthSelect = async (e) => {
    let list = [];
    list = [...selectedMarketAuth, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        aprlvl_cd: list1,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });

      setSelectedMarketAuth(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      let body = {
        aprlvl_cd: list2,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });

      setSelectedMarketAuth(list2);
    }
  };

  const handleFormSelect = async (e) => {
    let list = [];
    list = [...selectedForm, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        frmlvl_cd: list1,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });

      setSelectedForm(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        frmlvl_cd: list2,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });
      setSelectedForm(list2);
    }
  };

  const handleFormulationSelect = async (e) => {
    let list = [];
    list = [...selectedFormulation, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        stdlvl_cd: list1,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
      setSelectedFormulation(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        stdlvl_cd: list2,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
      setSelectedFormulation(list2);
    }
  };

  const handlePackSelect = (e, value) => {
    let list = [];
    list = [...selectedPackaging, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      setSelectedPackaging(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      setSelectedPackaging(list2);
    }
  };

  /*** 
  @purpose : Handle product change
  @Parameter : {value}
  **/
  const handleProductChange = async (value) => {
    setMarketLoading(true);
    if (value.length < selectedProducts.length && value.length > 0) {
      setSelectedProducts(value);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        prdctlvl_cd: value,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
    } else if (value.length === 0) {
      setMarketLoading(false);
      setSelectedProducts([]);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle market authorization change
  @Parameter : {value}
  **/
  const handleMarketAuthorizationChange = async (value) => {
    setFormLoading(true);
    if (value.length < selectedMarketAuth.length && value.length > 0) {
      setSelectedMarketAuth(value);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        aprlvl_cd: selectedProducts,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });
    } else if (value.length === 0) {
      setFormLoading(false);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle form change
  @Parameter : {value}
  **/
  const handleFormChange = async (value) => {
    setFormulationLoading(true);
    if (value.length < selectedForm.length && value.length > 0) {
      setSelectedForm(value);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        frmlvl_cd: selectedProducts,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });
    } else if (value.length === 0) {
      setFormulationLoading(false);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle formulation change
  @Parameter : {value}
  **/
  const handleFormulationChange = async (value) => {
    setPackLoading(true);
    if (value.length < selectedFormulation.length && value.length > 0) {
      setSelectedFormulation(value);
      setSelectedPackaging([]);
      let body = {
        stdlvl_cd: value,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
    } else if (value.length === 0) {
      setPackLoading(false);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle packaging change
  @Parameter : {value}
  **/
  const handlePackagingChange = (value) => {
    if (value.length > 0) {
      setSelectedPackaging(value);
    } else {
      setSelectedPackaging([]);
    }
  };

  const handleFacilityType = (e) => {
    let type = "";
    if (e.target.value === "parentFacility") {
      type = 1;
    } else if (e.target.value === "childFacility") {
      type = 2;
    }
    setFacilityType(type);
  };

  const handleHundredFloorChange = (value) => {
    setHundredFloorId(value.value);
  };

  const handleTwoHundredFloorChange = (value) => {
    setTwoHundredFloorId(value.value);
  };

  const handleEvaluationTargetChange = (value) => {
    setEvaluationTargetId(value.value);
  };

  const handleDoubleCountStatus = (e) => {
    setDoubleCountStatus(e.target.checked ? 1 : 0);
  };

  const handleSortItems = (e) => {
    setSortItem(e.target.value);
  };

  const handleNumericalItems = (e) => {
    setNumericalItem(e.target.value);
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page,{
      state: { page: "selloutFacility" },
    });
  };

  const getDailySelloutReportListing = () => {
    allSelected === 1 ? setShowUserMessage(true) : handleSelloutRotation();
  };

  const handleSelloutRotation = async () => {
    setLoading(true);
    setShowUserMessage(false);
    setNoData(false);
    setReportListing([]);
    setHeaders([]);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      alertPeriod: alertPeriod,
      facility_type: facilityType,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts?.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      double_count: doubleCountStatus,
      evaluation_target_classification: evaluationTargetId,
      fixed_month_japan_calendar: duration === 1,
      fromDate: fromDate,
      toDate: toDate,
      drug_price: numericalItem === "drugPrice" ? 1 : 0,
      number_of_boxes: numericalItem === "boxes" ? 1 : 0,
      received_and_paid_quantity: numericalItem === "quantity" ? 1 : 0,
      sort_items: sortItem,
      userType: "ALL",
      sort_field: "",
      sort_order: "",
      limit: 100,
    };
    await getSelloutRotationReportList(body).then((response) => {
      if (response.success === true && response.data.data.length > 0) {
        setReportListing(response && response.data.data);
        setHeaders(response.data.header);
        let count = response.data.total_count.split(",");
        setTotal(parseInt(count.join("")));
        setLimit(200);
        setShowUserMessage(false);
        setNoData(false);
        setLoading(false);
      } else if (
        (response.success === true && response.data.data.length === 0) ||
        response.success === false
      ) {
        setNoData(true);
        setLoading(false);
        setReportListing([]);
        setTotal();
      }
    });
  };

  // const handleContainerOnBottom = async () => {
  //   if (reportListing.length > 0) {
  //     setLazyLoading(true);
  //     let employeeList = [];
  //     details.map((emp) => employeeList.push(emp.wwid));
  //     let body = {
  //       employee_wwid:
  //         details && details.length > 0 ? employeeList : [personInCharge],
  //       employee_all_select: allSelected,
  //       alertPeriod: alertPeriod,
  //       facility_type: facilityType,
  //       "100_bed": hundredFloorId,
  //       "200_bed": twoHundredFloorId,
  //       product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
  //       market_authorization_l:
  //         selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
  //       form_l: selectedForm.length > 0 ? selectedForm : "ALL",
  //       formulation_l:
  //         selectedFormulation.length > 0 ? selectedFormulation : "ALL",
  //       pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
  //       double_count: doubleCountStatus,
  //       evaluation_target_classification: evaluationTargetId,
  //       fixed_month_japan_calendar: duration === 1,
  //       fromDate: fromDate,
  //       toDate: toDate,
  //       drug_price: numericalItem === "drugPrice" ? 1 : 0,
  //       number_of_boxes: numericalItem === "boxes" ? 1 : 0,
  //       received_and_paid_quantity: numericalItem === "quantity" ? 1 : 0,
  //       sort_items: sortItem,
  //       userType: "ALL",
  //       limit: limit,
  //       sort_field: sortField,
  //       sort_order: sortOrder,
  //     };
  //     setLazyLoading(false);
  //     if (reportListing.length <= total) {
  //       await getSelloutRotationReportList(body).then((response) => {
  //         let list = [];
  //         list = reportListing.concat(response && response.data.data);
  //         setReportListing(list);
  //       });
  //       setLimit(limit + 10);
  //     }
  //   }
  // };

  const loadRecords = async () => {
    if (reportListing.length > 0) {
      let employeeList = [];
      details.map((emp) => employeeList.push(emp.wwid));
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        alertPeriod: alertPeriod,
        facility_type: facilityType,
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        double_count: doubleCountStatus,
        evaluation_target_classification: evaluationTargetId,
        fixed_month_japan_calendar: duration === 1,
        fromDate: fromDate,
        toDate: toDate,
        drug_price: numericalItem === "drugPrice" ? 1 : 0,
        number_of_boxes: numericalItem === "boxes" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "quantity" ? 1 : 0,
        sort_items: sortItem,
        userType: "ALL",
        limit: limit,
        sort_field: sortField,
        sort_order: sortOrder,
      };
      if (reportListing.length < total) {
        setLazyLoading(true);
        await getSelloutRotationReportList(body).then((response) => {
          let list = [];
          list = reportListing.concat(response && response.data.data);
          setLazyLoading(false);

          setReportListing(list);
        });
        setLimit(limit + 100);
      }
    }
  };

  const handleExcelDownload = async () => {
    setExcelLoading(true);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      alertPeriod: alertPeriod,
      facility_type: facilityType,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      double_count: doubleCountStatus,
      evaluation_target_classification: evaluationTargetId,
      fixed_month_japan_calendar: duration === 1,
      fromDate: fromDate,
      toDate: toDate,
      drug_price: numericalItem === "drugPrice" ? 1 : 0,
      number_of_boxes: numericalItem === "boxes" ? 1 : 0,
      received_and_paid_quantity: numericalItem === "quantity" ? 1 : 0,
      sort_items: sortItem,
      userType: "ALL",
      view_type: "download",
      sort_field: sortField,
      sort_order: sortOrder,
      batch_size: 10000,
    };
    await getSelloutRotationReportList(body).then((response) => {
      setExcelLoading(false);
      if (Object.keys(response).includes("file")) {
        // window.location.href(response.file)
        var currentDate = new Date();
        var fullDate = new Date(currentDate),
          mnth = ("0" + (currentDate.getMonth() + 1)).slice(-2),
          day = ("0" + currentDate.getDate()).slice(-2),
          hr = ("0" + currentDate.getHours()).slice(-2),
          min = ("0" + currentDate.getMinutes()).slice(-2),
          sec = ("0" + currentDate.getSeconds()).slice(-2);
        var dt = [fullDate.getFullYear(), mnth, day].join("");
        var time = [hr, min, sec].join("");
        let fileName =
          "sellout_rotation_report_all_" + dt + "_" + time + ".xlsx";
        let file = response.file;
        fetch(file)
          .then((res) => res.blob())
          .then((data) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            link.click();
          });
      } else if (Object.keys(response).includes("data")) {
        setDownloadMessage(response.data);
        setShowDownloadMessage(true);
      }
    });
  };

  const handleSortingData = async (obj) => {
    // setLoading(true)
    // setReportListing([])
    setSortField(obj.column);
    setSortOrder(obj.sortOrder);
    obj.column === "target_person_name" && setSortPerson(obj.sortOrder);
    obj.column === "parent_facility_name" &&
      setSortParentFacility(obj.sortOrder);
    obj.column === "child_facility_name" &&
      setSortDeliveryFacility(obj.sortOrder);
    obj.column === "product_l" && setSortProduct(obj.sortOrder);
    obj.column === "market_authorization_l" && setSortMarket(obj.sortOrder);
    obj.column === "form_l" && setSortForm(obj.sortOrder);
    obj.column === "formulation_l" && setSortFormulation(obj.sortOrder);
    obj.column === "pack_l" && setSortPack(obj.sortOrder);
    obj.column === "non_delivery_period" &&
      setSortNonDeliveryPeriod(obj.sortOrder);
    // let list = compareBySortedData(obj);
    // setReportListing(list)
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    let body = {
      employee_wwid:
        details && details.length > 0 ? employeeList : [personInCharge],
      employee_all_select: allSelected,
      alertPeriod: alertPeriod,
      facility_type: facilityType,
      "100_bed": hundredFloorId,
      "200_bed": twoHundredFloorId,
      product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
      market_authorization_l:
        selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
      form_l: selectedForm.length > 0 ? selectedForm : "ALL",
      formulation_l:
        selectedFormulation.length > 0 ? selectedFormulation : "ALL",
      pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
      double_count: doubleCountStatus,
      evaluation_target_classification: evaluationTargetId,
      fixed_month_japan_calendar: duration === 1,
      fromDate: fromDate,
      toDate: toDate,
      drug_price: numericalItem === "drugPrice" ? 1 : 0,
      number_of_boxes: numericalItem === "boxes" ? 1 : 0,
      received_and_paid_quantity: numericalItem === "quantity" ? 1 : 0,
      sort_items: sortItem,
      userType: "ALL",
      sort_field: obj.column,
      sort_order: obj.sortOrder,
    };
    await getSelloutRotationReportList(body).then((response) => {
      if (response.success === true && response.data.data.length > 0) {
        setReportListing(response && response.data.data);
        setHeaders(response.data.header);
        let count = response.data.total_count.split(",");
        setTotal(parseInt(count.join("")));
        setShowUserMessage(false);
        setNoData(false);
        setLoading(false);
      } else if (
        (response.success === true && response.data.data.length === 0) ||
        response.success === false
      ) {
        setNoData(true);
        setLoading(false);
        setReportListing([]);
        setTotal();
      }
    });
  };

  const compareBySortedData = (obj) => {
    const sorted = reportListing.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) !== -1;
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  
  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "salesreport";
    const filteredTexts2 = {};
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return (
    <Home>
      <Breadcrumb finalText2={finalText2}  finalText={finalText} routes={routes} />
      {isScreenLoading && <Spinner animation="border" />}
      {maintenance === "1" && (
        <>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>{lang("SalesMenu.selloutRotationByFacility")}</Accordion.Header>
              <Accordion.Body>
                  <div className="user-details">
                    <div className="row">
                      <div className="col-md-3">
                        {lang("dailySellout.processingDate")}: {processingDate}
                      </div>
                      {/* <div className="col-md-3">
                    {lang("dailySellout.loginName")}: {loginName}
                  </div>
                  <div className="col-md-3">
                    {lang("dailySellout.organizationName")}: {organizationName}
                  </div> */}
                      <div className="col-md-3">
                        {lang("dailySellout.fixedMonth")}: {fromDateDisplay} -{" "}
                        {toDateDisplay}
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.personInCharge")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={personName}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <button
                              className="btn btn-primary"
                              onClick={(e) => changeRoute(e, "/searchMembers")}
                            >
                              {lang("dailySellout.selectPersonInCharge")}
                            </button>
                            <div className="custom-checkbox d-inline-block mr-3 ml-3 mb-2">
                              <input
                                type="checkbox"
                                id="status3"
                                name="status"
                                value={allSelected}
                                onChange={(e) => handleAllSelected(e)}
                              />
                              <label htmlFor="status3">
                                {lang("dailySellout.allSelection")}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <p className="annotations">
                            ★ {lang("annotations.personInChargeAnnotation")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3 mt-3 mb-4">
                      <div className="custom-radio d-inline-block">
                        <label htmlFor="order2">
                          {lang("dailySellout.alertPeriod")}
                        </label>
                      </div>
                    </div>
                    <div className="custom-9 mt-3 mb-4">
                      <div className="row">
                        <div className="col-md-3">
                          <Select
                            className="ant-select"
                            options={alertPeriodOptions}
                            placeholder="(Select alert period)"
                            onChange={handleAlertPeriodChange}
                            labelInValue={true}
                            showSearch
                            optionFilterProp="label"
                          />
                        </div>
                        <div className="col-md-3 mt-4">
                          <span>{lang("dailySellout.months")}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.product")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.productL")}</label>
                            <Select
                              mode="multiple"
                              className="ant-select"
                              options={productsList}
                              filterOption={filterOption}
                              placeholder={
                                lang("dailySellout.productL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedProducts}
                              // disabled={(details.length === 1)}
                              showSearch={
                                productsList && productsList.length > 0
                              }
                              onChange={handleProductChange}
                              onSelect={(e, value) =>
                                handleProductSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.marketAuthorizationL")}
                            </label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              // disabled={selectedProducts.length > 0 ? false : true}
                              filterOption={filterOption}
                              options={marketAuthList}
                              placeholder={
                                lang("dailySellout.marketAuthorizationL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedMarketAuth}
                              showSearch={
                                marketAuthList && marketAuthList.length > 0
                              }
                              loading={marketLoading}
                              onChange={handleMarketAuthorizationChange}
                              onSelect={(e, value) =>
                                handleMarketAuthSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.formL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={formList}
                              placeholder={
                                lang("dailySellout.formL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedForm}
                              // disabled={selectedMarketAuth.length > 0 ? false : true}
                              showSearch={
                                formList && formList.length > 0
                              }
                              loading={formLoading}
                              onChange={handleFormChange}
                              onSelect={(e, value) =>
                                handleFormSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.formulationL")}</label>
                            <Select
                              className="ant-select"
                              filterOption={filterOption}
                              mode="multiple"
                              options={formulationList}
                              value={selectedFormulation}
                              placeholder={
                                lang("dailySellout.formulationL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              // disabled={selectedForm.length > 0  ? false : true}
                              showSearch={
                                formulationList && formulationList.length > 0
                              }
                              loading={formulationLoading}
                              onChange={handleFormulationChange}
                              onSelect={(e, value) =>
                                handleFormulationSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.packL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={packagingList}
                              placeholder={
                                lang("dailySellout.packL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedPackaging}
                              // disabled={selectedFormulation.length > 0 ? false : true}
                              showSearch={
                                packagingList && packagingList.length > 0
                              }
                              loading={packLoading}
                              onChange={handlePackagingChange}
                              onSelect={(e, value) =>
                                handlePackSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.facilityType")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="parentFacility"
                              name="facility-order"
                              value="parentFacility"
                              onChange={(e) => handleFacilityType(e)}
                              defaultChecked
                            />
                            <label htmlFor="parentFacility">
                              {lang(
                                "parentChildFacilityMaintenance.parentFacility"
                              )}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="childFacility"
                              name="facility-order"
                              value="childFacility"
                              onChange={(e) => handleFacilityType(e)}
                            />
                            <label htmlFor="childFacility">
                              {lang("parentChildChangeRequest.childFacility")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("dailySellout.facilityClassification")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.hundredBedClassification")}
                            </label>
                            <Select
                              className="ant-select"
                              options={hundredBedsList}
                              defaultValue={hundredBedsList[0]}
                              placeholder={lang(
                                "dailySellout.hundredBedClassification"
                              )}
                              onChange={handleHundredFloorChange}
                              labelInValue={true}
                              showSearch
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.twoHundredBedClassification")}
                            </label>
                            <Select
                              className="ant-select"
                              options={twoHundredBedsList}
                              defaultValue={twoHundredBedsList[0]}
                              placeholder={lang(
                                "dailySellout.twoHundredBedClassification"
                              )}
                              onChange={handleTwoHundredFloorChange}
                              labelInValue={true}
                              showSearch
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang(
                                "dailySellout.evaluationTargetClassification"
                              )}
                            </label>
                            <Select
                              className="ant-select"
                              options={evaluationTargetClassificationList}
                              defaultValue={
                                evaluationTargetClassificationList[0]
                              }
                              placeholder={lang(
                                "dailySellout.evaluationTargetClassification"
                              )}
                              onChange={handleEvaluationTargetChange}
                              labelInValue={true}
                              showSearch
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.doubleCount")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="custom-checkbox d-inline-block mr-3 mt-3">
                        <input
                          type="checkbox"
                          id="count"
                          name="status"
                          value="6"
                          onChange={(e) => handleDoubleCountStatus(e)}
                        />
                        <label htmlFor="count">
                          {lang("dailySellout.include")}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form mt-3 mb-4">
                    <div className="custom-3">
                      <label>{lang("dailySellout.sortItems")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="parentFacilityCode"
                              name="sort-order"
                              value="parent_facility_code"
                              onChange={(e) => handleSortItems(e)}
                              defaultChecked
                            />
                            <label htmlFor="parentFacilityCode">
                              {lang("dailySellout.unifiedCode")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="parentFacilityName"
                              name="sort-order"
                              value="parent_facility_name"
                              onChange={(e) => handleSortItems(e)}
                            />
                            <label htmlFor="parentFacilityName">
                              {lang("dailySellout.unifiedName")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="nonDeliveryPeriod"
                              name="sort-order"
                              value="non_delivery_period"
                              onChange={(e) => handleSortItems(e)}
                            />
                            <label htmlFor="nonDeliveryPeriod">
                              {lang("dailySellout.nonDeliveryPeriod")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.numericalItems")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="drugPrice"
                              name="numerical-order"
                              value="drugPrice"
                              onChange={(e) => handleNumericalItems(e)}
                              defaultChecked
                            />
                            <label htmlFor="drugPrice">
                              {lang("dailySellout.salesAmount")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="boxes"
                              name="numerical-order"
                              value="boxes"
                              onChange={(e) => handleNumericalItems(e)}
                            />
                            <label htmlFor="boxes">
                              {lang("dailySellout.packageQuantity")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="quantity"
                              name="numerical-order"
                              value="quantity"
                              onChange={(e) => handleNumericalItems(e)}
                            />
                            <label htmlFor="quantity">
                              {lang("dailySellout.bulkQuantity")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={getDailySelloutReportListing}
                      disabled={loading}
                    >
                      {lang("dailySellout.display")}
                    </button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          {reportListing.length > 0 && (
            <div className="card">
              <div className="card-body">
                <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {reportListing.length} / {total}
                </p>
                <div
                  // ref={containerRef}
                  // onBottom={handleContainerOnBottom}
                  className="table-responsive mb-0 hover-table max-height"
                >
                  <table className="table" aria-describedby="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "target_person_name",
                              sortOrder: sortPerson === "desc" ? "asc" : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.targetPersonName")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        {headers.includes("parent_facility_name") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "parent_facility_name",
                                sortOrder:
                                  sortParentFacility === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.parentFacilityName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        )}
                        {headers.includes("child_facility_name") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "child_facility_name",
                                sortOrder:
                                  sortDeliveryFacility === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.childFacilityName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        )}
                        {headers.includes("product_l") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "product_l",
                                sortOrder:
                                  sortProduct === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.productL")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        )}
                        {headers.includes("market_authorization_l") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "market_authorization_l",
                                sortOrder:
                                  sortMarket === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.marketAuthorizationL")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        )}
                        {headers.includes("form_l") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "form_l",
                                sortOrder: sortForm === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.formL")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        )}
                        {headers.includes("formulation_l") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "formulation_l",
                                sortOrder:
                                  sortFormulation === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.formulationL")}
                              <em className="bx bxs-sort-a  lt"></em>
                            </div>
                          </th>
                        )}
                        {headers.includes("pack_l") && (
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "pack_l",
                                sortOrder: sortPack === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.packL")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        )}
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.year")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th
                          scope="col"
                          onClick={() =>
                            handleSortingData({
                              column: "non_delivery_period",
                              sortOrder:
                                sortNonDeliveryPeriod === "desc"
                                  ? "asc"
                                  : "desc",
                            })
                          }
                        >
                          <div className="cursor-pointer">
                            {lang("dailySellout.nonDeliveryPeriod")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.jan")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.feb")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.march")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.april")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.may")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.june")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.july")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.august")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.sept")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.oct")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.nov")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("dailySellout.dec")}
                            {/* <em className="bx bxs-sort-alt"></em> */}
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportListing &&
                        reportListing.length > 0 &&
                        reportListing.map((report, index) => {
                          let yearList = [];
                          yearList = Object.keys(report.monthlydata.January);
                          return (
                            <tr key={index}>
                              <td>{report.target_person_name}</td>
                              {headers.includes("parent_facility_name") && (
                                <td>{report.parent_facility_name}</td>
                              )}
                              {headers.includes("child_facility_name") && (
                                <td>{report.child_facility_name}</td>
                              )}
                              {headers.includes("product_l") && (
                                <td>{report.product_l}</td>
                              )}
                              {headers.includes("market_authorization_l") && (
                                <td>{report.market_authorization_l}</td>
                              )}
                              {headers.includes("form_l") && (
                                <td>{report.form_l}</td>
                              )}
                              {headers.includes("formulation_l") && (
                                <td>{report.formulation_l}</td>
                              )}
                              {headers.includes("pack_l") && (
                                <td>{report.pack_l}</td>
                              )}
                              <td>
                                {yearList.map((year, idx) => {
                                  return (
                                    <React.Fragment key={year}>
                                      <span>{year}</span>
                                      <br />
                                    </React.Fragment>
                                  );
                                })}
                              </td>
                              <td
                                className={
                                  report.non_delivery_period > alertPeriod
                                    ? "highlighted-cell"
                                    : ""
                                }
                              >
                                {report.non_delivery_period}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.January).map(
                                  (val, valIdx) => {
                                    return (
                                      <React.Fragment key={'jan_' + valIdx}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.February).map(
                                  (val, valIdx) => {
                                    return (
                                      <React.Fragment key={'feb_' + valIdx}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.March).map(
                                  (val) => {
                                    return (
                                      <>
                                        <span>{val}</span>
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.April).map(
                                  (val) => {
                                    return (
                                      <>
                                        <span>{val}</span>
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.May).map(
                                  (val) => {
                                    return (
                                      <>
                                        <span>{val}</span>
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.June).map(
                                  (val) => {
                                    return (
                                      <>
                                        <span>{val}</span>
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.July).map(
                                  (val) => {
                                    return (
                                      <>
                                        <span>{val}</span>
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.August).map(
                                  (val) => {
                                    return (
                                      <>
                                        <span>{val}</span>
                                        <br />
                                      </>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(
                                  report.monthlydata.September
                                ).map((val, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <span>{val}</span>
                                      <br />
                                    </React.Fragment>
                                  );
                                })}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.October).map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.November).map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  }
                                )}
                              </td>
                              <td>
                                {Object.values(report.monthlydata.December).map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  }
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="filter-actions mt-4 mb-4">
                  {excelLoading && <Spinner animation="border" />}
                  {lazyLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={handleExcelDownload}
                    disabled={excelLoading}
                  >
                    {lang("dailySellout.excelDownload")}
                  </button>
                  {total > 0 && (
                    <button
                      className="btn btn-primary"
                      onClick={loadRecords}
                      disabled={lazyLoading || reportListing.length >= total}
                    >
                      {lang("Buttons.loadMore")}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {loading === true && <Spinner animation="border" />}
          {noData && <div className="noData">No data found</div>}
          <Modal
            size="md"
            className="withdraw-modal"
            show={showUserMessage}
            onHide={handleCloseUserMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <p>{lang("dailySellout.allSelectionConfirmation")}</p>
                <p>{lang("dailySellout.run")}</p>
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleSelloutRotation}
                >
                  {lang("Buttons.ok")}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseUserMessage}
                >
                  {lang("Buttons.cancel")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            size="md"
            className="withdraw-modal"
            show={showDownloadMessage}
            onHide={handleCloseDownloadMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">{downloadMessage}</div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseDownloadMessage}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
      {maintenance === "0" && <SalesMaintenance />}
    </Home>
  );
}

export default SelloutRotationFacility;
